import React, { useCallback, useContext } from 'react';
import find from 'lodash/find';
import get from 'lodash/get';
import isNil from 'lodash/isNil';
import set from 'lodash/set';

import FormContext from 'src/presentation/contexts/FormContext';
import { TextareaField as ADTextareaField } from 'src/presentation/components/agent_desktop_components';

type TextareaFieldProps = {
  'data-aid'?: string;
  attr: string;
  autoFocus?: boolean;
  description?: string;
  disabled?: boolean;
  label?: string;
  onBlur?: Function;
  onChange?: Function;
  placeholder?: string;
  value?: string;
};

const TextareaField = ({
  'data-aid': dataAid,
  attr,
  autoFocus,
  description,
  disabled,
  label,
  onBlur,
  onChange,
  placeholder,
  value,
}: TextareaFieldProps) => {
  const { errors, workingState, updateState, resetError, onBlur: onBlurFromContext } = useContext(FormContext);
  const error = find(errors, error => error.attr === attr);

  const changed = useCallback(
    (val = '') => {
      if (onChange) {
        onChange(val);
      } else {
        resetError({ attr, errors });
        updateState(set({}, attr, isNil(val) ? '' : val));
      }
    },
    [updateState, onChange, resetError, errors, attr]
  );
  const val = !isNil(value) ? value : get(workingState, attr);

  return (
    <ADTextareaField
      autoFocus={autoFocus}
      data-aid={dataAid}
      description={description}
      disabled={disabled}
      error={get(error, 'detail')}
      label={label}
      onBlur={onBlur || onBlurFromContext}
      onChange={changed}
      placeholder={placeholder}
      value={val}
    />
  );
};

export default TextareaField;
